export default __webpack_public_path__ + "static/media/esquema-teixiduria.bb9ca716.png";